// src/contexts/AskContext.jsx
//
// AskContext provides the Ask popout callback and current scope to any
// descendant component without prop-drilling.
//
// App.jsx is the sole provider. AppHeaderBar consumes onAskOpen to render
// the "✦ Ask ⌘K" nav pill. LeaseSummaryTab consumes onAskOpen for the
// "Ask about this lease" scoped entry point. The ⌘K keyboard shortcut
// listener remains on `window` in App.jsx.

import { createContext, useContext } from "react";

/**
 * @typedef {Object} AskContextValue
 * @property {((overrideScope?: object|null) => void)|null} onAskOpen
 *   Call to open the Ask popout. Pass an override scope object to scoped
 *   queries, or null to clear scope. Undefined arg → use currentAskScope.
 *   Null when the ask_portfolio flag is off.
 * @property {{ type: string, id: string, label: string }|null} currentAskScope
 *   Active scope derived from the current view (location detail → location
 *   scope; portfolio pages → null).
 */

/** @type {React.Context<AskContextValue>} */
export const AskContext = createContext({
  onAskOpen: null,
  currentAskScope: null,
});

/** @returns {AskContextValue} */
export function useAsk() {
  return useContext(AskContext);
}
